import { inject, injectable } from "inversify";
import { BudgetTemplate } from "@project/domain/models/budget-template/budget-template";
import { BudgetTemplateRepositoryAbstract } from "@project/domain/repositories/budget-template.repository.abstract";

@injectable()
export class GetAllBudgetTemplatesUseCase {
    constructor(
        @inject(BudgetTemplateRepositoryAbstract)
        private readonly budgetTemplateRepository: BudgetTemplateRepositoryAbstract,
    ) { }

    async execute(): Promise<BudgetTemplate[]> {
        const result = await this.budgetTemplateRepository.getAllTemplates();
        return result.getOrElse([]);
    }
}
